var map = {
	"./1.png": "a014",
	"./2.png": "13e4",
	"./3.png": "379b",
	"./4.png": "607a",
	"./5.png": "4545",
	"./6.png": "f69f",
	"./7.png": "8684",
	"./8.png": "aabf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fde1";